import React, { memo, useEffect } from 'react';
import { loadClickAnalyticsActions } from '@coveo/headless';
import AddToCartProductTileReact from '../../global/modules/productTile/addToCartProductTileReact';
import { rentals_engine } from '../controllers/searchresultscontroller';
import { useAnalyticsContext } from '../../../config/GoogleTagManagerEvents';
import useAnalytics from '../../../hooks/useAnalytics';
import { EVENT_ECOMMERCE_NAMES_CONFIG } from '../../../constants/analyticsConstants/Ecommerce';

const SBRProductListing = props => {
    const { productState, totalResults } = props;
    const { sendEventsForEcommercePageData } = useAnalyticsContext();
    const [{ payloadEcommercePageData, sendAnalyticsForProductCardEvent }] = useAnalytics();

    useEffect(() => {
        if (productState?.results?.length > 0) {
            let lastItem = productState?.results[productState?.results?.length - 1];
            sendEventsForEcommercePageData(
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_DATA,
                payloadEcommercePageData(
                    lastItem?.raw?.ec_category
                        ? [lastItem?.raw?.ec_category[0], lastItem?.raw?.categoryl2, lastItem?.raw?.categoryl3]
                        : [lastItem?.raw?.categoryl2, lastItem?.raw?.categoryl3],
                    totalResults
                )
            );
        }
    }, []);

    useEffect(() => {
        if (productState?.results?.length < 4) {
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 0);
        }
    }, [productState?.results]);

    const sendDataToCoveo = async item => {
        const action = loadClickAnalyticsActions(rentals_engine).logDocumentOpen(item);
        await rentals_engine?.dispatch(action);
    };

    const renderProductTiles = () => {
        return productState?.results?.map((item, index) => {
            const cardData = {
                catclass: item?.raw?.ec_skus[0],
                producttitle: item?.Title,
                productimageurl: item?.raw?.ec_primary_image,
                producturl: item?.raw?.ec_product_url,
                showonlinecatalog: item?.raw?.ec_show_onlinecatalog === '1' ? 'YES' : 'NO',
                disableaddtocartoption: item?.raw?.ec_disable_addtocartoption === '1' ? 'YES' : 'NO',
                categoryname: item?.raw?.ec_category ? item?.raw?.ec_category[0] : '',
                category_path: item?.raw?.ec_category
                    ? [item?.raw?.ec_category[0], item?.raw?.categoryl2, item?.raw?.categoryl3]
                    : [item?.raw?.categoryl2, item?.raw?.categoryl3],
                position: index + 1,
                productcategoryname: item?.raw?.categoryl2,
                subcategoryname: item?.raw?.categoryl3,
                catsku: item?.raw?.ec_skus[0],
                catid: item?.raw?.ec_category_id,
                metatitle: item?.raw?.ec_meta_title,
                metadescription: item?.raw?.ec_meta_description,
                specialtytypes: item?.raw?.ec_specialtytypes,
                inventory: item?.raw?.ec_pc_inventory,
                specialtytypescode: item?.raw?.ec_specialtytypecode,
                analysisgroupcode: item?.raw?.ec_analysisgroupcode
            };
            return (
                <div className="col-md-3 col-lg-4 col-6 plp__item" key={`${item?.raw?.ec_skus[0]}${index}`}>
                    <AddToCartProductTileReact
                        handleClick={(args = null) => sendDataToCoveo(item)}
                        cardData={cardData}
                        trackAnalytics={sendAnalyticsForProductCardEvent}
                    />
                </div>
            );
        });
    };
    return (
        <>
            <div className="row plp__list">{renderProductTiles()}</div>
        </>
    );
};

export default memo(SBRProductListing);
